var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceOutlineRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ef5658;stroke:#ef5658;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.5,1.619a.611.611,0,0,0-.6-.011L21.289,5.216V3.051A3.054,3.054,0,0,0,18.238,0H3.051A3.054,3.054,0,0,0,0,3.051V15.1a3.054,3.054,0,0,0,3.051,3.051H18.238A3.054,3.054,0,0,0,21.289,15.1V12.971L27.9,16.579a.61.61,0,0,0,.9-.536V2.143A.61.61,0,0,0,28.5,1.619ZM20.068,15.1a1.832,1.832,0,0,1-1.831,1.831H3.051A1.833,1.833,0,0,1,1.22,15.1V3.051A1.833,1.833,0,0,1,3.051,1.22H18.238a1.833,1.833,0,0,1,1.831,1.831Zm7.511-.082-6.29-3.435V6.606l6.29-3.434Zm0,0",
    transform: "translate(1.6 6.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOutlineRed);
export default __webpack_public_path__ + "static/media/device_outline_red.f6f7d8b6bace7d900c2db4258e7ffb8d.svg";
export { ForwardRef as ReactComponent };